export default __webpack_public_path__ + "static/NBInternationalPro-Light-0311b0f60fdf762f0e4e7995bd67911e.eot";